/**
 * Error state component for API errors
 */

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({ 
  title = 'Ошибка загрузки', 
  message = 'Не удалось загрузить данные. Проверьте подключение к интернету и попробуйте снова.',
  onRetry,
  retryLabel = 'Повторить'
}: ErrorStateProps) {
  return (
    <div className="card card--error">
      <div className="error-state">
        <div className="error-state__icon">⚠️</div>
        <div className="error-state__title">{title}</div>
        <div className="error-state__message">{message}</div>
        {onRetry && (
          <button onClick={onRetry} className="error-state__retry">
            {retryLabel}
          </button>
        )}
      </div>
    </div>
  );
}

